import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'



class Onac extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            padding: 100px 0 30px;
            background-color: #ffffff;            
        `

        const Heading2 = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            line-height: 80px;
            color: #000;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            margin-bottom: 100px; 
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
                line-height: 70px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading3 = styled.h3`
            font-size: 40px;
            color: #000;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #84a841);
            background: -o-linear-gradient(right, #c1eb18, #84a841);
            background: -moz-linear-gradient(right, #c1eb18, #84a841);
            background: linear-gradient(to right, #c1eb18, #84a841); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 35px;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #84a841;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #48565e;
            padding-bottom: 30px;
        `

        const Element = styled.div`
      margin-bottom: 20px;
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }
      transition: 0.2s;
      &:hover {
        transform: translateY(-10px);
      }
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `


        return (
            <Section>
                <Container>
                    <Content>
                        <Heading2>
                            ¿Necesitan las Autoridades de Certificación (CA) o sus distribuidores en Colombia la Acreditación ONAC?
                        </Heading2>
                        <Text>
                            La acreditación ONAC no es obligatoria para vender o usar certificados SSL en Colombia, a pesar de mitos de algunas entidades certificadoras Colombianas. Protege tu sitio, app o plataforma
                            web en Bogotá, Medellín, Barranquilla, Cartagena sin complicaciones.
                        </Text>
                        <Heading3>
                            Entendiendo las Implicaciones
                        </Heading3>
                        <Separator />
                        <Text>
                            En el mundo de la seguridad en línea, las Autoridades de Certificación (CA) juegan un papel fundamental al emitir certificados
                            digitales SSL que garantizan la autenticidad y seguridad de los sitios web. Sin embargo, existe un falso "mito" a si
                            estas entidades o sus distribuidores necesitan o están obligados a obtener la acreditación del Organismo Nacional de Acreditación de Colombia
                            (ONAC), y qué implicaciones tiene esto en la seguridad en línea. En este artículo, exploraremos este tema en profundidad
                            y arrojaremos luz sobre esta cuestión.
                        </Text>
                        <Heading3>
                            ¿Qué es la Acreditación ONAC y por qué es importante?
                        </Heading3>
                        <Separator />
                        <Text>
                            El Organismo Nacional de Acreditación de Colombia (ONAC) es una entidad encargada de evaluar y certificar la competencia técnica y la
                            imparcialidad de los organismos de evaluación de la conformidad, como laboratorios de ensayo, organismos de certificación y organismos
                            de inspección "Colombianos". La acreditación ONAC es una certificación oficial de que un organismo cumple con los estándares y requisitos establecidos,
                            lo que garantiza la calidad y la confiabilidad de sus servicios.
                        </Text>
                        <Heading3>
                            ¿Están obligadas las CA a obtener la Acreditación ONAC?
                        </Heading3>
                        <Separator />
                        <Text>
                            A diferencia de otros tipos de organismos de evaluación de la conformidad, las <strong>Autoridades de Certificación (CA) de SSL</strong>, no están obligadas por ley a obtener
                            la acreditación del ONAC. Esto se debe a que las CA operan en un ámbito internacional y están sujetas a regulaciones y estándares globales, como los
                            establecidos por el Foro de Gobernanza de Internet (IGF), el WebTrust (administrado por la American Institute of Certified Public Accountants (AICPA) en
                            asociación con la Canadian Institute of Chartered Accountants - CICA), todos los nevegadores web y el Centro de Normas de Internet (ISC). Estas organizaciones internacionales establecen
                            pautas y prácticas recomendadas para las CA, pero no requieren específicamente la acreditación ONAC.
                        </Text>

                    </Content>
                    <Row>
                        <Col md={6}>

                            <Heading3>
                                ¿Entonces, tengo que tener la acreditación ONAC para vender los SSL?
                            </Heading3>
                            <Separator />
                            <Text>
                                <strong>No,</strong> ya que sobre la emisión de certificados de servidor seguro SSL, <strong>prima las regulaciones y estándares globales</strong> y no las Colombianas. Esto es una falsa obligación
                                que se han inventado algunas entidades de certificación Colombianas (entidades que no emiten los SSL, sino otro tipo de certificación), engañando a los usuarios, sobre todo del sector público.
                            </Text>
                            <Text>
                                No existe en Colombia ninguna ley o norma que obligue a las CA o sus distribuidores a tener dicha acreditación para emitir y vender los SSL.
                            </Text>
                            <Heading3>
                                Implicaciones de la Acreditación ONAC para las CA
                            </Heading3>
                            <Separator />
                            <Text>
                                Es importante tener en cuenta que la falta de acreditación ONAC no necesariamente indica una falta de calidad o confiabilidad en los servicios de una CA o sus distribuidores. <strong>Todas las CA</strong> a
                                nivel mundial de SSL, <strong>operan sin esta acreditación</strong> y siguen siendo reconocidas y confiadas por millones de usuarios, navegadores y organizaciones en todo el mundo.
                            </Text>
                            <Text>
                                De hecho, <strong>ninguna entidad de certificación Colombiana, emite Certificados Digitales SSL o Certificados de servidor seguro SSL</strong>. Todos los certificados SSL a nivel mundial, son emitidos por entidades
                                de certificación extranjeras o internacionales.
                            </Text>

                        </Col>
                        <Col md={6}>

                            <Element>
                                <GatsbyImage image={this.props.image} alt="SSL sin acreditación ONAC" sizes="(max-width: 767px) 300px, 500px"  />
                            </Element>

                        </Col>
                    </Row>
                </Container>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {
          file(relativePath: { eq: "entidades-de-certificacion-colombianas.jpg" }) {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: DOMINANT_COLOR
                quality: 80
                formats: [AUTO, WEBP, AVIF]
                width: 500
              )
            }
          }
        }
      `}
        render={(data) => {
            const image = getImage(data.file.childImageSharp.gatsbyImageData);
            return <Onac image={image} {...props} />;
        }}
    />
);

export default Iconos;
